import React, { FC, useMemo } from 'react';

import cn from 'classnames';
import Calender from 'components/Calender';
import { parseTimeString, serialize24HoursTime } from 'core/datetime';

import { ReactComponent as CrossIcon } from 'assets/cross.svg';
import { ReactComponent as UndoIcon } from 'assets/undo.svg';

const formatTime = (t: string) => serialize24HoursTime(parseTimeString(t));

interface TimelineWidgetProps extends CourseTimelineClass {
  onClassToggle(id: string): void;
}

const TimelineWidget: FC<TimelineWidgetProps> = ({
  id,
  startTimeUnix,
  endTimeUnix,
  venue,
  isOnlineMeeting,
  onClassToggle: onDelete,
  isRemoved = false,
}) => {
  const schedule = useMemo(() => {
    const sDate = new Date(startTimeUnix * 1000);
    const eDate = new Date(endTimeUnix * 1000);

    const sTime = `${sDate.getHours()}:${sDate.getMinutes()}`;
    const eTime = `${eDate.getHours()}:${eDate.getMinutes()}`;

    return { date: sDate, sTime: formatTime(sTime), eTime: formatTime(eTime) };
  }, [startTimeUnix, endTimeUnix]);

  return (
    <div className={cn('timeline-widget has-tooltip', { 'timeline-widget--removed': isRemoved })}>
      <Calender className='timeline-widget__date' date={schedule.date} />
      <div className='timeline-widget__info'>
        <div className='bold'>
          {schedule.sTime} - {schedule.eTime}
        </div>
        {isOnlineMeeting ? <div>This class is online</div> : <div>Venue: {venue}</div>}
      </div>
      <button
        type='button'
        className={cn('timeline-widget__action tooltip-trigger left', { red: !isRemoved, blue: isRemoved })}
        data-tooltip={isRemoved ? 'Undo remove' : 'Remove class'}
        onClick={() => onDelete(id)}
      >
        {isRemoved ? <UndoIcon /> : <CrossIcon />}
      </button>
    </div>
  );
};

export default TimelineWidget;
